import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import BigNumber from 'bignumber.js/bignumber'
import { useWeb3React } from '@web3-react/core/core/core'
import {  Flex, Link, Text, Button, Box, Message, ChevronDownIcon, SubMenu, SubMenuItem, Card} from '@pancakeswap/uikit'
import orderBy from 'lodash/orderBy'
import partition from 'lodash/partition'
import { useTranslation } from 'contexts/Localization'
import usePersistState from 'hooks/usePersistState'
import { useFetchPublicPoolsData, usePools, useFetchCakeVault, useCakeVault  } from 'state/poolsDrop6/hooks'
import { usePollFarmsData , usePriceCakeBusd } from 'state/farms/hooks'
import FlexLayout from 'components/Layout/Flex' 
import Page from 'components/Layout/Page'
import PageHeader from 'components/PageHeader'
import Select, { OptionProps } from 'components/Select/Select'
import { useVaultApprove, useCheckVaultApprovalStatus } from 'views/Faucet5/hooks/useApprove';
import { Pool } from 'state/types'
import { ViewMode } from './components/ToggleView/ToggleView'
import { getAprData, getCakeVaultEarnings } from './helpers'
import BountyCard2 from './components/BountyCard2'
 
const Divider = styled.div`
  background-color: ${({ theme }) => theme.colors.backgroundDisabled};
  height: 1px;
  margin: 16px auto;
  width: 100%;
`
 
const ImageWrapper = styled.div`
margin: 0 auto;
${({ theme }) => theme.mediaQueries.md} {
  margin: 0 auto;

}
`
const ButtonText = styled(Text)`
display: none;
${({ theme }) => theme.mediaQueries.xs} {
  display: block;
}
`
const ScrollBox = styled(Box)`
padding: 10px;
background: linear-gradient(
  -72deg,
  #ad913e,
  #ad913e 16%,
  #ad913e 21%,
  #ad913e 24%,
  #ad913e 27%,
  #ad913e 36%,
  #ad913e 45%,
  #ad913e 60%,
  #ad913e 72%,
  #ad913e 80%,
  #ad913e 84%,
  #ad913e
  );
  border: 0.05px solid ${({ theme }) => theme.colors.gold};
margin-right: 20px;
width: 250px; 
margin-bottom: 20px;
border-radius: 20px;
${({ theme }) => theme.mediaQueries.md} {
  background: linear-gradient(
    -72deg,
    #ad913e,
    #ad913e 16%,
    #ad913e 21%,
    #ad913e 24%,
    #ad913e 27%,
    #ad913e 36%,
    #ad913e 45%,
    #ad913e 60%,
    #ad913e 72%,
    #ad913e 80%,
    #ad913e 84%,
    #ad913e
    );
    margin-right: 20px;
  border: 0.05px solid ${({ theme }) => theme.colors.gold};
  margin-bottom: 20px;
  width: 250px; 
  padding: 10px;
  border-radius: 10px; 
}
`
const ScrollBox3 = styled(Box)`
padding: 10px;
background: linear-gradient(
  -72deg,
  #e0e0fc,
  #e0e0fc 16%,
  #e0e0fc 21%,
  #e0e0fc 24%,
  #e0e0fc 27%,
  #e0e0fc 36%,
  #e0e0fc 45%,
  #e0e0fc 60%,
  #e0e0fc 72%,
  #e0e0fc 80%,
  #e0e0fc 84%,
  #e0e0fc
  );
  border: 0.05px solid ${({ theme }) => theme.colors.gold};
margin-right: 20px;
width: 250px; 
margin-bottom: 20px;
border-radius: 20px;
${({ theme }) => theme.mediaQueries.md} {
  background: linear-gradient(
    -72deg,
    #e0e0fc,
    #e0e0fc 16%,
    #e0e0fc 21%,
    #e0e0fc 24%,
    #e0e0fc 27%,
    #e0e0fc 36%,
    #e0e0fc 45%,
    #e0e0fc 60%,
    #e0e0fc 72%,
    #e0e0fc 80%,
    #e0e0fc 84%,
    #e0e0fc
    );
    margin-right: 20px;
  border: 0.05px solid ${({ theme }) => theme.colors.gold};
  margin-bottom: 20px;
  width: 250px; 
  padding: 10px;
  border-radius: 10px; 
}
`
const ScrollBox2 = styled(Box)`
padding: 10px;

background:linear-gradient(
  -72deg,
  #C0C0C0,
  #C0C0C0 16%,
  #C0C0C0 21%,
  #C0C0C0 24%,
  #C0C0C0 27%,
  #C0C0C0 36%,
  #C0C0C0 45%,
  #C0C0C0 60%,
  #C0C0C0 72%,
  #C0C0C0 80%,
  #C0C0C0 84%,
  #C0C0C0
);
border: 0.05px solid ${({ theme }) => theme.colors.gold};
margin-right: 20px;
width: 250px; 
margin-bottom: 20px;
border-radius: 20px;
${({ theme }) => theme.mediaQueries.md} {
  background: linear-gradient(
    -72deg,
    #C0C0C0,
    #C0C0C0 16%,
    #C0C0C0 21%,
    #C0C0C0 24%,
  );
  margin-right: 20px;
  border: 0.05px solid ${({ theme }) => theme.colors.gold};
  margin-bottom: 20px;
  width: 250px; 
  padding: 10px;
  border-radius: 10px; 
}
`
const Faucet5: React.FC = () => {
  const location = useLocation()
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const { pools: poolsWithoutAutoVault, userDataLoaded } = usePools(account)
  const loadMoreRef = useRef<HTMLDivElement>(null)
  const [viewMode, setViewMode] = usePersistState(ViewMode.TABLE, { localStorageKey: 'pancake_pool_view' })
  const [searchQuery, setSearchQuery] = useState('')
  const [sortOption, setSortOption] = useState('hot')
  const chosenPoolsLength = useRef(0)
  const {
    userData: { cakeAtLastUserAction, userShares },
    fees: { performanceFee },
    pricePerFullShare,
    totalCakeInVault,
  } = useCakeVault()
  const accountHasVaultShares = userShares && userShares.gt(0)
  const performanceFeeAsDecimal = performanceFee && performanceFee / 100

  const pools = useMemo(() => {
    const cakePool = poolsWithoutAutoVault.find((pool) => pool.sousId === 0)
    const cakeAutoVault = { ...cakePool, isAutoVault: true }
    return [cakeAutoVault, ...poolsWithoutAutoVault]
  }, [poolsWithoutAutoVault])

 
  const all = pools.filter((pool) => pool.sousId !== -1 && pool.tokensymbol5  === 'ALL110000')

  const VIZSLAPRICE0 = usePriceCakeBusd()
 
  const VIZSLAPRICE = VIZSLAPRICE0.toNumber()

  const { isVaultApproved, setLastUpdated } = useCheckVaultApprovalStatus()




  // TODO aren't arrays in dep array checked just by reference, i.e. it will rerender every time reference changes?
  const [finishedPools, openPools] = useMemo(() => partition(pools, (pool) => pool.isFinished), [pools])
  const stakedOnlyFinishedPools = useMemo(
    () =>
      finishedPools.filter((pool) => {
        if (pool.isAutoVault) {
          return accountHasVaultShares
        }
        return pool.userData && new BigNumber(pool.userData.stakedBalance).isGreaterThan(0)
      }),
    [finishedPools, accountHasVaultShares],
  )
  const stakedOnlyAllPools = useMemo(
    () =>
      all.filter((pool) => {
        if (pool.isAutoVault) {
          return accountHasVaultShares
        }
        return pool.userData && new BigNumber(pool.userData.stakedBalance).isGreaterThan(0)
      }),
    [all, accountHasVaultShares],
  )
  const hasStakeInFinishedPools = stakedOnlyFinishedPools.length > 0

  usePollFarmsData()
  useFetchCakeVault()
  useFetchPublicPoolsData()



  const handleChangeSearchQuery = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value)
  }

  const handleSortOptionChange = (option: OptionProps): void => {
    setSortOption(option.value)
  }

  const sortPools = (poolsToSort: Pool[]) => {
    switch (sortOption) {
      case 'apr':
        // Ternary is needed to prevent pools without APR (like MIX) getting top spot
        return orderBy(
          poolsToSort,
          (pool: Pool) => (pool.apr ? getAprData(pool, performanceFeeAsDecimal).apr : 0),
          'desc',
        )
      case 'earned':
        return orderBy(
          poolsToSort,
          (pool: Pool) => {
            if (!pool.userData || !pool.earningTokenPrice) {
              return 0
            }
            return pool.isAutoVault
              ? getCakeVaultEarnings(
                  account,
                  cakeAtLastUserAction,
                  userShares,
                  pricePerFullShare,
                  pool.earningTokenPrice,
                ).autoUsdToDisplay
              : pool.userData.pendingReward.times(pool.earningTokenPrice).toNumber()
          },
          'desc',
        )
      case 'totalStaked':
        return orderBy(
          poolsToSort,
          (pool: Pool) => (pool.isAutoVault ? totalCakeInVault.toNumber() : pool.totalStaked.toNumber()),
          'desc',
        )
      default:
        return poolsToSort
    }
  }


  return (
    <>
      <PageHeader>
        <Flex justifyContent="space-between" flexDirection={['column', null, null, 'row']}>
          <Flex flex="1" flexDirection="column" mr={['8px', 0]}>
          <Flex alignItems="center" justifyContent="space-between">
        <ImageWrapper>
        <img src="/images/pixel/pppp.png" alt="ifo bunny" width="100%" height="100%"/>
      </ImageWrapper>
      </Flex>
          </Flex>
        </Flex>
      </PageHeader>
      <Page>
      <Flex justifyContent="center" alignItems="center"  mr="-20px" mb="-20px" >
      <ScrollBox2>

<Flex flexDirection="column"   justifyContent="center"  alignItems="center"
>
   <ImageWrapper>
    <img  src="/images/pixel/K2.png"  alt="ifo bunny" width="100px" height="100px"/>
  </ImageWrapper>
  <Text color="background"  bold fontSize="20px" mt="4px">
                {t('Silver')}
              </Text>
              <Text color="text"  bold fontSize="14px" mt="4px">
                {t('Trade crypto instantly')}
              </Text>
              <Text color="text"  bold fontSize="14px" mt="4px">
                {t('on multiple routers.')} 
              </Text> 
              <Link  href="/swap" >
          <Button  variant="tertiary" height="40px" mb="5px" mt="10px" width="100px">
          <ButtonText color="text" bold fontSize="14px">
      {t('TRADE NOW')}
    </ButtonText>
          </Button>
        </Link>
  </Flex>
            </ScrollBox2>
            <ScrollBox>

<Flex flexDirection="column"   justifyContent="center"  alignItems="center"
>
   <ImageWrapper>
    <img  src="/images/pixel/K3.png"  alt="ifo bunny" width="100px" height="100px"/>
  </ImageWrapper>
  <Text color="background"  bold fontSize="20px" mt="4px">
                {t('Gold')}
              </Text>
              <Text color="text"  bold fontSize="14px" mt="4px">
                {t('Stake crypto tokens')}
              </Text>
              <Text color="text"  bold fontSize="14px" mt="4px">
                {t('earn various rewards.')} 
              </Text>
              <Link  href="/pools/all">
          <Button  variant="tertiary" height="40px" mb="5px" mt="10px" width="100px">
          <ButtonText color="text" bold fontSize="14px">
      {t('EARN NOW')}
    </ButtonText>
          </Button>
        </Link>
  </Flex>  
            </ScrollBox>
            <ScrollBox3>

<Flex flexDirection="column"   justifyContent="center"  alignItems="center"
>
   <ImageWrapper>
    <img  src="/images/pixel/K4.png"  alt="ifo bunny" width="100px" height="100px"/>
  </ImageWrapper>
  <Text color="background"  bold fontSize="20px" mt="4px">
                {t('Platinum')}
              </Text>
              <Text color="text"  bold fontSize="14px" mt="4px">
                {t('Stake crypto tokens')}
              </Text>
              <Text color="text"  bold fontSize="14px" mt="4px">
                {t('earn various rewards.')} 
              </Text>
              <Link  href="/pools/all">
          <Button  variant="tertiary" height="40px" mb="5px" mt="10px" width="100px">
          <ButtonText color="text" bold fontSize="14px">
      {t('EARN NOW')}
    </ButtonText>
          </Button>
        </Link> 
  </Flex>  
            </ScrollBox3>
            </Flex>
      </Page>
    </>
  )
}

export default Faucet5
